export enum PurchaseStatus {
  DRAFT = "Draft",
  PENDING = "Pending",
  COMPLETED = "Completed",
  RETURNED = "Returned",
}

export enum PurchasePaymentStatus {
  PAID = "Paid",
  PARTIAL = "Partial",
  DUE = "Due",
}

export interface PurchaseItem {
  id?: number | string;
  purchase_id?: number | string;
  product_id: number | string;
  product_title?: string;
  product_sku?: string;
  product_unit?: string;
  product_barcode?: string;
  stock_id?: number | string | null;
  variant_id?: number | string | null;
  variant_name?: string | null;
  variant_data?: any;
  cost_price: number;
  retail_price: number;
  wholesale_price: number;
  quantity: number;
  profit_margin?: number | null;
  discount_percent: number;
  total: number;
  batch_no?: string;
  stock_option: "new" | "existing";
  stock_batch_no?: string;
  expiry_date?: string | null;
}

export interface Purchase {
  id: number | string;
  supplier_id: number | string;
  supplier_name?: string;
  purchase_date: string;
  invoice_no?: string | null;
  po_no?: string | null;
  total_amount: number;
  discount_amount: number;
  grand_total: number;
  paid_amount: number;
  due_amount: number;
  payment_status: PurchasePaymentStatus;
  due_date?: string | null;
  status: PurchaseStatus;
  created_by?: number | string | null;
  created_by_username?: string | null;
  created_at?: string;
  items?: PurchaseItem[];
}
